// Format numbers with JQuery number plugin
// https://github.com/customd/jquery-number
export default function() {

	let decimals = $('.number-display').attr('data-scale');
	if (typeof decimals === 'undefined') {decimals = 5;}
	$('.number-display').number( true, decimals );

}